
import { Heart, Pill, CalendarCheck, FileText, Baby, Brain } from "lucide-react";

export const patientMenuItems = [
  { 
    icon: Heart,
    label: "Patient",
    items: [
      { icon: Pill, label: "Médicaments", path: "/medicaments" },
      { icon: CalendarCheck, label: "Rendez-vous", path: "/rendez-vous" },
      { icon: FileText, label: "Journal", path: "/journal" },
      { icon: Heart, label: "Suivi de cycle menstruel", path: "/period-tracking" },
      { icon: Baby, label: "Suivi de grossesse", path: "/gestation-tracking" },
      { icon: Brain, label: "Assistance IA", path: "/ai-assistance" },
    ]
  }
];
